import { TypeContext } from "./form/useForm"


export default class RenderingStrategy
{
    /**
     * Name of the rendering strategy
     * @type {string}
     */
    name = "Unnamed";
    /**
     * Rendering function
     *
     * fn(palette) => ...
     *
     * @type {function}
     */
    fn = null

    defaultConfig = null
    
    constructor(name, fn, defaultConfig = {})
    {
        this.name = name
        this.fn = fn
        this.defaultConfig = defaultConfig
        this.desc = new TypeContext(name).typeDef.description
    }
}
